import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { toast } from 'sonner';
import { z } from 'zod';
import useManageSubGroup from './hooks/useManageSubGroup';

const manageSubGroupFormSchema = z.object({
  groupName: z.string().min(1, { message: 'Required' }),
  groupNameKatakana: z.string().min(1, { message: 'Required' }),
  subGroupName: z.string().min(1, { message: 'Required' }),
});

export const ManageSubGroupForm = ({
  defaultValues,
  groupId,
  subGroupId,
}: {
  defaultValues?: { groupName: string; groupNameKatakana: string; subGroupName?: string };
  defaultGroupDetailValues?: { groupName: string; groupNameKatakana: string; subGroupName?: string };
  groupId?: string;
  subGroupId?: string;
}) => {
  const { mutateAsync } = useManageSubGroup(groupId);
  const formDefaultValues = defaultValues ?? {
    groupName: '',
    groupNameKatakana: '',
    subGroupName: '',
  };

  const form = useForm({ schema: manageSubGroupFormSchema, mode: 'onBlur', defaultValues: formDefaultValues });

  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        if (!groupId) {
          toast.error('Group ID is required to create a subgroup.');
          return;
        }

        await mutateAsync({
          groupId,
          subGroupId: subGroupId ?? '',
          groupName: data.groupName,
          groupNameKatakana: data.groupNameKatakana,
          subGroupName: data.subGroupName,
        });
      }}
    >
      <div className="w-full flex flex-col gap-4.5">
        <div className="gap-4.5 grid grid-cols-2">
          <Input
            label="configurationManagement.groupsManagement.manageSubGroups.groupName"
            {...form.register('groupName')}
            disabled
          />
          <Input
            label="configurationManagement.groupsManagement.manageSubGroups.groupNameKatakana"
            {...form.register('groupNameKatakana')}
            disabled
          />
        </div>
        <Input
          label="configurationManagement.groupsManagement.manageSubGroups.subGroupName"
          {...form.register('subGroupName')}
        />
      </div>
    </Form>
  );
};
